
// export const environment = {
//   production: true,
//   apiUrlBase: 'https://cicerone.cms-iurban.com',
//   urlWebSocket: 'wss://gpt.cms-iurban.com/ws/assistant',
//   urlWebSocketTools: 'wss://gpt.cms-iurban.com/ws/assistant/tool-feedback',
//   urlChatHistory: 'https://gpt.cms-iurban.com/v2/get_conversation',
//   urlTextToSpeech: 'https://gpt.cms-iurban.com/tts/stream'
// };

// export const environment = {
//   production: false,
//   apiUrlBase: 'https://cicerone.cms-iurban.com',
//   apiAssistantUrlBase: 'http://localhost:8005',
//   urlWebSocket: 'ws://localhost:8005/ws/assistant',
//   urlWebSocketTools: 'ws://localhost:8005/ws/assistant/tool-feedback',
//   urlChatHistory: 'http://localhost:8005/api/chat/history',
//   urlTextToSpeech: 'http://localhost:8005/tts/stream'
// };


// export const environment = {
//   production: true,
//   apiUrlBase: 'http://4.231.60.12:8005',
//   apiAssistantUrlBase: 'http://4.231.60.12:8005',
//   urlWebSocket: 'ws://4.231.60.12:8005/ws/assistant',
//   urlWebSocketTools: 'ws://4.231.60.12:8005/ws/assistant/tool-feedback',
//   urlChatHistory: 'http://4.231.60.12:8005/api/chat/history',
//   urlTextToSpeech: 'http://4.231.60.12:8005/tts/stream'
// };

export const environment = {
  production: true,
  apiUrlBase: 'https://dev.gpt.cms-iurban.com',
  apiAssistantUrlBase: 'https://dev.gpt.cms-iurban.com',
  urlWebSocket: 'wss://dev.gpt.cms-iurban.com/ws/assistant',
  urlWebSocketTools: 'wss://dev.gpt.cms-iurban.com/ws/assistant/tool-feedback',
  urlChatHistory: 'https://dev.gpt.cms-iurban.com/api/chat/history',
  urlTextToSpeech: 'https://dev.gpt.cms-iurban.com/tts/stream'
};